export const scrollToSection = (targetId: string, extraOffset = 20) => {
    const target = document.getElementById(targetId);
    if (!target) return;

    const header = document.querySelector('header');
    const headerHeight = header?.getBoundingClientRect().height || 0;
    // When scrollY is 0, the header is still `position: relative` and occupies
    // space in the document flow. Scrolling away from the top makes it switch
    // to `position: fixed` (see header.tsx `scrolled` state), which removes it
    // from the flow and shifts all content up by headerHeight. That shift only
    // happens once, so it must be accounted for in addition to the fixed
    // header's overlay height, or the target ends up headerHeight too low.
    const headerIsFixed = header?.classList.contains('fixed');
    const reflowShift = headerIsFixed ? 0 : headerHeight;

    const targetPosition =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        headerHeight -
        reflowShift -
        extraOffset;

    window.scrollTo({ top: targetPosition, behavior: 'smooth' });
};
